module.exports = __webpack_public_path__ + "img/folder_eye.139b592e.svg";